import { useMessagedAsyncRetry } from "@payping/web-components";
import { getBusinessSettingIban, getIbans } from "@payping/redux/actions";
import { useAppDispatch } from "@/utils";

export const useIbans = () => {
  const dispatch = useAppDispatch();

  const { loading, retry } = useMessagedAsyncRetry(
    async () => {
      await dispatch(getIbans({ pageNumber: 1, pageSize: 50 }));
      await dispatch(getBusinessSettingIban());
    },
    [],
    { useProgress: true },
  );

  return { loading, retry };
};
